type SelectableCourse = {
  id: string;
};

export const buildCourseCheckedState = (
  bucketedCourses: SelectableCourse[][],
  isChecked: boolean
): Record<string, boolean> => {
  const newCheckedState: Record<string, boolean> = {};

  Object.values(bucketedCourses)
    .flat()
    .forEach((course) => {
      newCheckedState[course.id] = isChecked;
    });

  return newCheckedState;
};
